import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SecurityConcept from '../components/SecurityConcept';
import WidgetFirst from '../components/WidgetFirst';
import SecuredNavigation from '../components/SecuredNavigation';
import AlertSystem from '../components/AlertSystem';

const FonctionnalitesPage = () => {
  useEffect(() => {
    document.title = 'Fonctionnalités — MonAlerte';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <SecurityConcept />
        <WidgetFirst />
        <SecuredNavigation />
        <AlertSystem />
      </main>
      <Footer />
    </>
  );
};

export default FonctionnalitesPage;
